import clsx from 'clsx';
import React from 'react';
import { textColorStyles } from '../styles/colors';

export interface DisplayProps {
  children: React.ReactNode;
  className?: string;
  color?: 'primary-black' | 'primary-white';
  size?: 'tiny' | 'small' | 'medium' | 'large' | 'extraLarge';
  as?: 'h1' | 'h2' | 'p';
}

const FONT_FAMILY = 'Inter, sans-serif';
const FONT_WEIGHT = 'var(--font-weight-extrabold)';

const sizeStyles = {
  tiny: { fontSize: '3rem', lineHeight: '3rem' },
  small: { fontSize: '3.75rem', lineHeight: '3.75rem' },
  medium: { fontSize: '4.5rem', lineHeight: '4.5rem' },
  large: { fontSize: '6rem', lineHeight: '6rem' },
  extraLarge: { fontSize: '8rem', lineHeight: '8rem' },
};

export const Display = ({
  children,
  className,
  color = 'primary-black',
  size = 'small',
  as: Component = 'h1',
}: DisplayProps) => (
  <Component
    className={clsx(textColorStyles[color], className)}
    style={{
      fontFamily: FONT_FAMILY,
      ...sizeStyles[size],
      fontWeight: FONT_WEIGHT,
    }}
  >
    {children}
  </Component>
);
